// src/reduxStore/modules/tenants/actions.js

import * as types from './types';
import SPBackend from '../../../services/SPBackend';
import { log } from '../../../utils/jsUtils';
import { setLoadingModule, setSnackMessage } from '../common';

export const setTenantEnableUpload = (enabled, isUserAction = false) => ({
  type: types.SET_TENANT_ENABLE_UPLOAD,
  payload: { enabled, isUserAction }
});

export const setUserExplicitlyEnabledUpload = (enabled) => ({
  type: types.SET_USER_EXPLICITLY_ENABLED_UPLOAD,
  payload: enabled
});

export const setTenants = (tenants) => ({
  type: types.SET_TENANTS,
  payload: tenants
});

export const setTenantDetails = (details) => ({
  type: types.SET_TENANT_DETAILS,
  payload: details
});

export const setTenantConversations = (conversations) => ({
  type: types.SET_TENANT_CONVERSATIONS,
  payload: conversations
});

export const setCurrentTenant = (tenant) => ({
  type: types.SET_CURRENT_TENANT,
  payload: tenant
});

export const fetchTenants = (user) => async (dispatch) => {
  try {
    dispatch(setLoadingModule('tenants', true));
    
    const response = await SPBackend.getTenants(user);
    dispatch(setTenants(response.data));
  } catch (error) {
    log('[fetchTenants] error:', error);
    dispatch(setSnackMessage({
      message: 'Failed to load tenants.',
      variant: 'error'
    }));
  } finally {
    dispatch(setLoadingModule('tenants', false));
  }
};

export const fetchTenantDetails = (tenantId, user) => async (dispatch) => {
  try {
    dispatch(setLoadingModule('tenantDetails', true));
    
    const response = await SPBackend.getTenantDetails(tenantId, user);
    dispatch(setTenantDetails(response.data));
  } catch (error) {
    log('[fetchTenantDetails] error:', error);
    dispatch(setSnackMessage({
      message: 'Failed to load tenant details.',
      variant: 'error'
    }));
  } finally {
    dispatch(setLoadingModule('tenantDetails', false));
  }
}; 